import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';
import { LabelFormAppManager } from 'apps/issueTracker/newLabelForm/appManager';

@observer
export class NewLabelForm extends Modal {
  UNSAFE_componentWillMount() {
    const { issueTracker } = modalStore.props;
    this.appManager = new LabelFormAppManager(issueTracker, modalStore.props);
  }

  render() {
    const { labelFormApp } = this.appManager;
    const { newLabelForm } = labelFormApp;
    const {
      conf: { formTitle },
    } = newLabelForm;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={newLabelForm}
          formTitle=''
          buttonHandler={this.appManager.Submit}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
